import React from 'react'
import Modal from 'react-modal'
import ScoreGraph from './ScoreGraph'

const ScoreGraphModal = ({isOpen, onClose, history, teams, missions}) => {
  return (
    <Modal
        isOpen={isOpen}
        onRequestClose={() => {onClose()}}
        className="bg-white p-6 rounded-lg shadow-lg mx-auto mt-20 relative min-w-[340px] w-4/5 "
        overlayClassName="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center"
    >
        {/* ✕ボタン */}
        <button className='absolute top-4 right-4 text-gray-600 text-lg hover:text-gray-800' onClick={() => {onClose()}}>
            <i className='bi bi-x-lg'></i>
        </button>

        <div className='overflow-x-auto w-full'>
            <div className='min-w-[800px]'>
            <ScoreGraph history={history} teams={teams} missions={missions} />
            </div>
        </div>
    </Modal>
  )
}

export default ScoreGraphModal